/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */


import { PanoramaController     } from "@/components/panorama.controller";
import { Event                  } from "@/components/krpano/events/event";
import { EventType              } from "@/components/krpano/events/event.type";
import { KeyboardEvent          } from "@/components/krpano/events/keyboard.event";

/**
 *
 * @class KeyboardActions
 *
 * Helper to map hot keys to appropriate actions
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2022
 *
 */
export class KeyboardActions {

  constructor(
    private controller: PanoramaController,
  ) {

  }

  hotkey(e: KeyboardEvent) {

    let ka: KeyboardActions = this;

    if (!e.up()) {

      /* just do the action when they let go of the key not both when they press and when they let go */
      return ;
    }

    if ((e.key() == 'w') || (e.key() == 'W')) {

      /* next pano */

      ka.controller.navigateNext();
      return ;
    }

    if ((e.key() == 's') || (e.key() == 'S')) {

      /* previous pano */

      ka.controller.navigatePrevious();
      return ;
    }

    if ((e.key() == 'a') || (e.key() == 'A')) {

      /* jump to track to the left */

      ka.controller.navigateLeft();
      return ;
    }

    if ((e.key() == 'd') || (e.key() == 'D')) {

      /* jump to track to the right */

      ka.controller.navigateRight();
      return ;
    }

    if ((e.key() == 'r') || (e.key() == 'R')) {

      /* reset/center the panoramic view */

      ka.controller.reset();
      return ;
    }

    if ((e.key() == 'm') || (e.key() == 'M')) {

      /* toggle the minimap */

      ka.controller.toggleVisible();
      return ;
    }

    if ((e.key() == 'f') || (e.key() == 'F')) {

      /* toggle mile post selector */

      ka.controller.toggleFilter();
      return ;
    }

    if ((e.key() == 'c') || (e.key() == 'C')) {

      /* hide/show the control bar*/

      ka.controller.toggleControls();
      return ;
    }

    if ((e.key() == 'o') || (e.key() == 'O')) {

      /* return to overview page */

      ka.controller.navigateOverwatch();
      return ;
    }

    if ((e.key() == 'p') || (e.key() == 'P')) {

      /* reset/center the panoramic view */

      ka.controller.milePostFocus();
      return ;
    }

    if (e.key() == 'F11') {

      ka.controller.toggleFullscreen();
      return ;
    }
  }

}
